/** Trigger a browser download of `content` as a file named `filename`. */
export function downloadTextFile(
  filename: string,
  content: string,
  mime = 'application/json'
): void {
  const blob = new Blob([content], { type: mime })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  link.remove()
  URL.revokeObjectURL(url)
}
